import { Input } from '@angular/core';
import { XOField } from "./xo-field.component"

export class XOArrayField extends XOField {
  @Input() displayAddButton = true;
  @Input() minLength?;
  @Input() maxLength?;
}
